import { render, staticRenderFns } from "./SideButtons.vue?vue&type=template&id=63e50894&"
import script from "./SideButtons.vue?vue&type=script&lang=js&"
export * from "./SideButtons.vue?vue&type=script&lang=js&"
import style0 from "./SideButtons.vue?vue&type=style&index=0&id=63e50894&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports